import { css } from '@emotion/core'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import SVGIcon from './SvgIcon'

interface SignIconProps {
  type: 'checkmark' | 'cross' | 'warning'
  id?: string
  className?: string
  color?: string
}

const SignIcon: React.FC<SignIconProps> = ({ type, id, className, color }) => {
  return <SVGIcon src={`signs/${type}`} id={id} className={className} css={iconStyle(type, color)} />
}

export default SignIcon

const iconStyle = (type: string, color: any) => css`
  min-width: ${type === 'checkmark-new' || type === 'cross-new' ? '11px' : '25px'};
  width: ${type === 'checkmark-new' || type === 'cross-new' ? '11px' : '25px'};
  height: ${type === 'checkmark-new' || type === 'cross-new' ? '11px' : '25px'};

  ${(type === 'checkmark-new' || type === 'cross-new') && 'transform: translateY(7px)'};

  ${color &&
  `
    path,
    circle {
      stroke: ${color};
      ${type === 'warning' && `&:nth-child(3) {fill: ${color}}`};
    }
  `}

  @media screen and (max-width: ${breakpoints.small}px) {
    min-width: 20px;
    width: 20px;
    height: 20px;
  }
`
